import { render, staticRenderFns } from "./IconicPerfumeCard.vue?vue&type=template&id=fbadddb4&scoped=true"
import script from "./IconicPerfumeCard.vue?vue&type=script&lang=js"
export * from "./IconicPerfumeCard.vue?vue&type=script&lang=js"
import style0 from "./IconicPerfumeCard.vue?vue&type=style&index=0&id=fbadddb4&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbadddb4",
  null
  
)

export default component.exports